var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "datasetSelection",
        "content-class": "generic-release-modal",
        "dialog-class": "dataset-panel-dialog",
        size: _vm.drtComponents ? "lg" : "md",
        "hide-footer": "",
        centered: "",
      },
      on: {
        hide: _vm.handleClose,
        show: function ($event) {
          _vm.selected = false
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c(
                "div",
                { staticClass: "grm-header d-flex align-items-center w-100" },
                [
                  _c("div", { staticClass: "grm-header-icon" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          viewBox: "0 0 24 24",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("circle", {
                          attrs: {
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "#4db8ff",
                            "stroke-width": "1.5",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10A15.3 15.3 0 0 1 12 2z",
                            stroke: "#4db8ff",
                            "stroke-width": "1.5",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M4.93 4.93a16 16 0 0 1 14.14 0M4.93 19.07a16 16 0 0 0 14.14 0",
                            stroke: "#4db8ff",
                            "stroke-width": "1.5",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "grm-header-text" }, [
                    _c("h5", { staticClass: "grm-title mb-0" }, [
                      _vm._v("Select a Release"),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "grm-subtitle mb-0" }, [
                      _vm._v("Choose a dataset to explore on the map"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "grm-header-badge ml-auto" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.releaseCount) +
                        " release" +
                        _vm._s(_vm.releaseCount !== 1 ? "s" : "") +
                        " available\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("fa", {
                    staticClass: "dataset-close-btn",
                    attrs: { icon: ["fas", "times"] },
                    on: {
                      click: function ($event) {
                        return close()
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm.ansiComponent
        ? _c("MMP_ANSI_DatasetPanel", {
            attrs: {
              apiUrl: _vm.apiUrl,
              currentExtent: _vm.selectedExtent,
              customerName: _vm.customerName,
              releases: _vm.ansiReleases,
              selectedDataset: _vm.selectedDataset,
              user: _vm.user,
              ansiLayersButtonCtrl: _vm.ansiLayersButtonCtrl,
            },
            on: {
              extentChanged: function ($event) {
                return _vm.$emit("extentChanged", $event)
              },
              returnHome: function ($event) {
                return _vm.$emit("returnHome")
              },
              setSelectedDataset: function ($event) {
                return _vm.$emit("setSelectedDataset", $event)
              },
              updateANSILayersPartNumber: function ($event) {
                return _vm.$emit("updateANSILayersPartNumber", $event)
              },
              updateSelset: function ($event) {
                return _vm.$emit("updateSelset", $event)
              },
              unloadLayers: function ($event) {
                return _vm.$emit("unloadLayers", $event)
              },
              selection: function ($event) {
                _vm.selected = true
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.drtComponents
        ? _c("MMP_DRT_DatasetPanel", {
            attrs: {
              currentExtent: _vm.selectedExtent,
              releases: _vm.releases,
              selectedDataset: _vm.selectedDataset,
              user: _vm.user,
            },
            on: {
              extentChanged: function ($event) {
                return _vm.$emit("extentChanged", $event)
              },
              returnHome: function ($event) {
                return _vm.$emit("returnHome")
              },
              setSelectedDataset: function ($event) {
                return _vm.$emit("setSelectedDataset", $event)
              },
              setShowDRTLayers: function ($event) {
                return _vm.$emit("setShowDRTLayers")
              },
              updateDRTLayersPartNumber: function ($event) {
                return _vm.$emit("updateDRTLayersPartNumber", $event)
              },
              selection: function ($event) {
                _vm.selected = true
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }